/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OrgUserAdminUpdate
 */
export interface OrgUserAdminUpdate {
    /**
     * 
     * @type {string}
     * @memberof OrgUserAdminUpdate
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserAdminUpdate
     */
    org_user_azure_id: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserAdminUpdate
     */
    role: string;
    /**
     * 
     * @type {string}
     * @memberof OrgUserAdminUpdate
     */
    organization_azure_id: string;
}

/**
 * Check if a given object implements the OrgUserAdminUpdate interface.
 */
export function instanceOfOrgUserAdminUpdate(value: object): value is OrgUserAdminUpdate {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('org_user_azure_id' in value) || value['org_user_azure_id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    if (!('organization_azure_id' in value) || value['organization_azure_id'] === undefined) return false;
    return true;
}

export function OrgUserAdminUpdateFromJSON(json: any): OrgUserAdminUpdate {
    return OrgUserAdminUpdateFromJSONTyped(json, false);
}

export function OrgUserAdminUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): OrgUserAdminUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'org_user_azure_id': json['org_user_azure_id'],
        'role': json['role'],
        'organization_azure_id': json['organization_azure_id'],
    };
}

export function OrgUserAdminUpdateToJSON(json: any): OrgUserAdminUpdate {
    return OrgUserAdminUpdateToJSONTyped(json, false);
}

export function OrgUserAdminUpdateToJSONTyped(value?: OrgUserAdminUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'org_user_azure_id': value['org_user_azure_id'],
        'role': value['role'],
        'organization_azure_id': value['organization_azure_id'],
    };
}

